
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Init } from './app/app.init';
import '@datadog/browser-rum/bundle/datadog-rum';
import '@datadog/browser-logs/bundle/datadog-logs';


const init = new Init();

if (environment.production) {
    enableProdMode();
}

declare global {
    interface Window {
        DD_RUM: any;
        DD_LOGS: any;
    }
}

if (environment.ddg_enabled) {
    window.DD_RUM.init({
        applicationId: '89f84450-7209-49c8-8cd8-b4ec6c69be0d',
        clientToken: 'pubcd1efdff00f43f0700580450c664b532',
        site: 'datadoghq.com',
        service: 'login-xref-com',
        env: environment.env,
        sampleRate: 100,
        sessionReplaySampleRate: 0,
        trackInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [/https:\/\/.*\.xref\.com/, /https:\/\/.*\.xref\.io/ ]
    });
    window.DD_RUM.startSessionReplayRecording();
}

if (environment.ddg_enabled) {
    window.DD_LOGS.init({
        service: 'login-xref-com',
        env: environment.env,
        clientToken: 'pubcd1efdff00f43f0700580450c664b532',
        site: 'datadoghq.com',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: "all",
        sampleRate: 100
    });
}

function getEnvironment() {
    if ( environment.DOMAIN != 'localhost' ) {
        const url = window.location.href;
        if (url.includes('dev')) {
            return 'dev';
        }
        if (url.includes('sandbox')) {
            return 'sandbox';
        }
        return 'prod';
    }
}

if (init.browserSupported) {
    init.destroyUnsupportedBrowser();
    platformBrowserDynamic().bootstrapModule(AppModule);

} else {
    init.showUnsupportedBrowser();
}
